export const TEMPLATES_GET_LIST = 'TEMPLATES_GET_LIST'
export const TEMPLATES_USE = 'TEMPLATES_USE'
